import getters from '@/store/modules/mq/mqCommonState/mq.getters';
import mutations from '@/store/modules/mq/mqCommonState/mq.mutations';
import actions from '@/store/modules/mq/mqCommonState/mq.actions';
import { messageQueueList,emptyKeyLabelObj, emptyKeyLabelListWithPermissions } from '@/components/MQ/mq.types';
import { KeyLabel } from "@/store/mutations-typesCommon";
import mq from '@/utils/templates/mq.template';
import { kafkaOverviewComponents } from '@/components/MQ/Kafka/kafka.types';
import { Service } from '@/utils/types/global';

export interface State {
    currentMQType: KeyLabel,
    currentMQService: Service,
    currentBroker: KeyLabel,
    currentMQSubType: KeyLabel,
    brokerVersionList: KeyLabel[],
    queueList: KeyLabel[],
    topicList: KeyLabel[],
    producerList: KeyLabel[],
    currentProducer: KeyLabel,
    consumerList: KeyLabel[],
    zookeeperList: KeyLabel[],
    brokerList: KeyLabel[],
    brokerTopicList: KeyLabel[],
    activeTab: String,
}

export const initialState: State = {
    currentMQType: messageQueueList[0],
    currentMQService: emptyKeyLabelListWithPermissions,
    currentBroker: emptyKeyLabelObj,
    currentMQSubType: mq.navTabs[0].tabs[0],
    brokerVersionList: [emptyKeyLabelObj],
    queueList: [emptyKeyLabelObj],
    topicList: [emptyKeyLabelObj],
    producerList: [emptyKeyLabelObj],
    currentProducer: emptyKeyLabelObj,
    consumerList: [emptyKeyLabelObj],
    zookeeperList: [emptyKeyLabelObj],
    brokerList: [emptyKeyLabelObj],
    brokerTopicList: [emptyKeyLabelObj],
    activeTab: kafkaOverviewComponents()[0].key,
}

export default {
  namespaced: true,
  state: initialState,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
